<template>
    <common-modal :heading="heading" :headingCenter="true" width="large" height="max-height-small">
        <common-content-wrapper width="large">
            <common-table v-if="companies.length">
                <thead>
                    <tr>
                        <th>{{ $t('layouts.app.main_menu.company') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="company in companies" :key="company.id">
                        <td :data-label="$t('layouts.app.main_menu.company')">
                            <span>{{ company.name }}</span>
                        </td>
                        <td class="td-center">
                            <common-button
                                type="primary"
                                size="tiny"
                                :isFluid="true"
                                :label="$t('common.microcopy.select')"
                                @click="emitEvent({ name: 'company-selected', payload: company })"
                            ></common-button>
                        </td>
                    </tr>
                </tbody>
            </common-table>
            <div v-else>
                <common-buttons>
                    <common-button
                        :label="$t('common.microcopy.close')"
                        :isSubmittable="false"
                        type="secondary"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                    <common-button
                        :label="$t('common.microcopy.true')"
                        :isSubmittable="false"
                        type="primary"
                        @click="emitEvent({ name: 'create-company' })"
                    ></common-button>
                </common-buttons>
            </div>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    export default {
        props: {
            companies: { type: Array, default: () => [] },
        },

        computed: {
            heading() {
                return this.companies?.length
                    ? this.$t('layouts.app.main_menu.my_companies')
                    : this.$t('forms.company.create_company.no_companies')
            },
        },
    }
</script>
